import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { LABELS, type CyclePhase, type SessionState } from "@match/shared";
import type { AccountConflict } from "@/lib/types";

const CONFLICT_STATE: Record<AccountConflict["state"], string> = { ATTIVO: "attivo", ARCHIVIATO: "archiviato", ELIMINATO: "eliminato" };
const CONFLICT_ROLE: Record<AccountConflict["role"], string> = { PROP: "prop", BROKER: "broker", NONE: "senza ruolo" };

/**
 * DOVE STA IL CONTO CHE TIENE QUEL NUMERO (`409 LOGIN_TAKEN`): stato, cliente,
 * etichetta, Fase e ciclo in cui e' usato, e «Apri». Si porta in vista da solo:
 * su un form lungo, un errore in fondo restava fuori dallo schermo.
 */
export function AccountConflictNote({ message, conflict, onOpen }: { message: string; conflict: AccountConflict; onOpen: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.scrollIntoView?.({ block: "nearest" });
  }, []);
  const uso = conflict.usedIn;
  return (
    <div ref={ref} role="alert" className="space-y-1 rounded border border-loss/40 bg-loss/10 px-3 py-2 text-sm">
      <p className="text-loss">{message}</p>
      <p>
        <span className="font-medium">{conflict.label}</span> · {CONFLICT_ROLE[conflict.role]} · <span className="font-mono">{conflict.mt5Login}</span> su {conflict.serverName} —{" "}
        <span className="font-medium">{CONFLICT_STATE[conflict.state]}</span>, cliente {conflict.client.name}
        {conflict.client.isArchived && <span className="font-medium text-warn"> (cliente archiviato)</span>}.
      </p>
      <p className="text-xs text-muted">
        {uso
          ? `Usato nella ${LABELS.cyclePhase[uso.phase as CyclePhase] ?? uso.phase} ${uso.symbol} (${LABELS.sessionState[uso.sessionState as SessionState] ?? uso.sessionState})${uso.cycle ? `, ciclo ${uso.cycle.label ?? "senza nome"}` : ", senza ciclo"}.`
          : "Non è usato da nessuna Fase."}
      </p>
      <Link to={conflict.link.path} onClick={onOpen} className="inline-block text-sm text-accent underline-offset-2 hover:underline">
        {conflict.link.label}
      </Link>
    </div>
  );
}
